




































































import Vue, { PropType } from 'vue';

// Types and services
import { VFair, VFairUser } from '~/services/VFairService';
import UserInfoService from '~/services/UserInfoService';

// Components
import VFairListSkeleton from '../../../../components/skeletons/VFairListSkeleton.vue';
import DateRange from '../../components/DateRange.vue';
import OngoingBadge from '../../components/OngoingBadge.vue';
import VisibilityBadge from '../../components/VisibilityBadge.vue';
import defaultBackground from '~/assets/img/vcf/event-default-bg.png';
import SchoolVFairInfo from './SchoolVFairInfo.vue';
import VFairListItemSkeleton from '~/components/skeletons/VFairListItemSkeleton.vue';
import NoContent from '~/components/miscellaneous/NoContent.vue';

// Utils
import { buildIDParam } from '~/utils/urlUtils';
import { RestXReactiveData } from '~/utils/types';
import DialogService from '~/services/DialogService';
import { VFairAccess, calculateVFairAccess } from '../../utils';

export default Vue.extend({
    name: 'VFairList',
    components: {
        VFairListSkeleton,
        DateRange,
        OngoingBadge,
        VisibilityBadge,
        VFairListItemSkeleton,
        NoContent,
    },
    props: {
        data: {
            type: Array as PropType<VFair[]>,
            default: () => [],
        },
        initialLoading: Boolean,
        loading: Boolean,
    },
    data() {
        return {};
    },
    computed: {
        vfairuser(): RestXReactiveData<VFairUser[]> {
            if (this.$interfaces.logInModule.isLoggedIn()) {
                return this.$interfaces.vfairuser.user.me.get({
                    reactive: true,
                });
            } else {
                return {
                    loading: true,
                    data: [],
                    error: null,
                };
            }
        },
        defaultBackground() {
            return defaultBackground;
        },
    },
    methods: {
        vfairuserData(): VFairUser[] {
            return this.vfairuser.data;
        },
        vfairuserLoaded(): boolean {
            return this.vfairuser.loading !== false && this.vfairuser.data !== null;
        },
        getInterested(id: string): boolean {
            let data = this.vfairuserData().filter(data => data.vfairId === id);
            if (data && data[0]) {
                return data[0].interested;
            }
            return false;
        },
        vFairRoute(vfair: VFair): string {
            return this.$URLS.vfairs.concat(
                '/',
                buildIDParam(vfair.id, vfair.title),
                this.$URLS.vfairDetails
            );
        },
        enterVFair(vfair: VFair) {
            this.$router.push(this.vFairRoute(vfair));
        },
        async gotoVFair(vfair: VFair) {
            return calculateVFairAccess(vfair, { awaitCSPs: false })
                .then(result => {
                    switch (result.access) {
                        case VFairAccess.Access:
                            this.enterVFair(vfair);
                            return;
                        case VFairAccess.NoEducation:
                            // The student has no education in their profile
                            DialogService.openDialog({
                                title: vfair.title,
                                content: this.$t('vfair.missingEducationProfileMessage'),
                                actions: [
                                    {
                                        title: this.$t('vfair.missingEducationProfileButtonLabel'),
                                        action: ({ res }: { res: () => void }) => {
                                            res();
                                            this.$router.push(this.$URLS.profile);
                                        },
                                        variant: 'primary',
                                    },
                                ],
                                isError: false,
                            });
                            return;
                        case VFairAccess.NotVerified: {
                            const schoolName =
                                result.cspsInVFair && result.cspsInVFair.length > 0
                                    ? result.cspsInVFair[0].studyProgram.school?.name
                                    : '' || '';
                            DialogService.openDialog({
                                title: vfair.title,
                                content: this.$t('vfair.studentNotVerifiedSchoolMessage', {
                                    schoolName,
                                }),
                                // actions: [],
                                isError: false,
                            });
                            return;
                        }
                        case VFairAccess.NoAccess: {
                            // The student's school has not joined the school.
                            const isHigheredAdmin = UserInfoService.isHigheredAdmin();
                            const isCompanyAdmin = UserInfoService.getOrgAdminIds().length > 0;

                            const notJoinedMessage = isCompanyAdmin
                                ? this.$t('vfair.companyNotJoinedNetworkEventMessage')
                                : this.$t('vfair.schoolNotJoinedNetworkEventMessage');

                            const actions = isHigheredAdmin
                                ? [
                                      {
                                          title: "Well, since you're an admin, you can proceed",
                                          action: ({ res }: { res: () => void }) => {
                                              res();
                                              this.$router.push(this.vFairRoute(vfair));
                                          },
                                          variant: 'primary',
                                      },
                                  ]
                                : undefined;

                            DialogService.openDialog({
                                title: vfair.title,
                                content: notJoinedMessage,
                                actions: actions,
                                isError: false,
                            });
                            return;
                        }
                    }
                })
                .catch(console.error);
        },
        openSchoolInfo() {
            DialogService.openDialog({
                title: this.$t('vfair.privateVFairHeader'),
                component: SchoolVFairInfo,
                actions: [],
                clickawayOff: false,
            });
        },
    },
});
